// extracted by mini-css-extract-plugin
export default {"tabWrapper":"SlideMenuAdBodyTab_tabWrapper__nX-I2","wholeWrapper":"SlideMenuAdBodyTab_wholeWrapper__86SqB","adImage":"SlideMenuAdBodyTab_adImage__wcfjl"};